import { render, staticRenderFns } from "./FuncionarioExport.vue?vue&type=template&id=4981efd8"
import script from "./FuncionarioExport.vue?vue&type=script&lang=js"
export * from "./FuncionarioExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports